import type { ContractRecordMap, Rest } from '@libs/data-access/entities'
import { Alert } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { membershipsSelectors } from '@spa/scenes/Plannings/redux/selectors'
import { keyBy } from 'lodash-es'
import type { FC } from 'react'
import React from 'react'

type Props = {
  contracts: ContractRecordMap
  restsSuccess: Partial<Rest>[]
}

export const RestSuccessfullyCreated: FC<Props> = ({
  contracts,
  restsSuccess = []
}) => {
  const { t } = usePlanningFormTranslation()
  const contractById = keyBy(contracts.toArray(), 'id')

  return (
    <Alert intent='semantic.blue' title={t('restForm.success')}>
      {restsSuccess.map(rest => {
        const membership = membershipsSelectors.useGetCachedById(
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          contractById[rest.user_contract_id]?.membership_id
        )
        return (
          <div className='my-1' key={rest.user_contract_id}>
            {t('restForm.listedContractFullname', {
              value: {
                firstname: membership?.firstname,
                lastname: membership?.lastname
              }
            })}
          </div>
        )
      })}
    </Alert>
  )
}
